export default {
  props: {
    testPotProductId: {
      type: Number,
      default: null,
    },
    product: {
      type: Object,
      required: true,
    },

    palettes: {
      type: Array,
      required: true,
    },

    sheens: {
      type: Array,
      required: true,
    },

    sizes: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      selectedColour: this.palettes[0]?.colours[0],
      selectedSheen: this.sheens.length ? this.sheens[0] : false,
      selectedSize: this.sizes.length ? this.sizes[0] : {},
      variant: null,
      testPot: null,
      init: true,
    };
  },

  watch: {
    selectedColour() {
      this.setQueryString();
      if (!this.init) {
        this.getData();
      }
    },
    selectedSheen() {
      this.setQueryString();
      if (!this.init) {
        this.changeSheen();
      }
    },
    selectedSize() {
      this.setQueryString();
    },
  },

  async created() {
    // Set init flag so that we can manipulate the initial state
    this.init = true;
    const { colourParam, sheenParam, sizeParam } = this.getQueryParams();

    let ids = {};

    if (colourParam || sheenParam || sizeParam) {
      ids = await this.getQueryIds({
        colour: colourParam,
        sheen: sheenParam,
        size: sizeParam,
      });
    }

    const { colour } = ids || null;
    const { sheen } = ids || null;
    const { size } = ids || null;

    if (colour) {
      this.setColourFromParam(colour);
    }

    await this.getData();

    if (sheen) {
      this.setSheenFromParam(sheen);
    }

    if (size) {
      this.setSizeFromParam(size);
    }

    // Offset the time of the artificial loading
    // And end the init phase
    setTimeout(() => {
      this.init = false;
    }, 1000);
  },

  methods: {
    getQueryIds() {
      throw new Error(
        "Components consuming this mixin must implement the getQueryIds method"
      );
    },

    getData() {
      throw new Error(
        "Components consuming this mixin must implement the getData method"
      );
    },

    paramify(arg) {
      return arg.toLowerCase().replaceAll(" ", "-");
    },

    setQueryString() {
      const colour = `colour=${
        this.selectedColour?.id ? this.selectedColour?.slug : ""
      }`;
      const sheen = `sheen=${
        this.selectedSheen?.id ? this.selectedSheen?.slug : ""
      }`;
      const size = `size=${
        this.selectedSize?.id ? this.selectedSize?.slug : ""
      }`;
      window.history.replaceState(
        { page: 1 },
        "title 1",
        `?${colour}&${sheen}&${size}`
      );
    },

    getQueryParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const colourParam = urlParams.get("colour");
      const sheenParam = urlParams.get("sheen");
      const sizeParam = urlParams.get("size");
      return { colourParam, sheenParam, sizeParam };
    },

    setColourFromParam(colour) {
      this.selectedColour = colour;
      const { hex, textColour } = this.selectedColour;
      this.$store.commit("setSiteTheme", [hex, textColour]);
      this.$store.commit("setPaintTheme", [hex, textColour]);
    },

    setSheenFromParam(sheen) {
      if (
        this.variantSheens.some((variantSheen) => variantSheen.id === sheen?.id)
      ) {
        this.selectedSheen = sheen;
      }
    },

    setSizeFromParam(size) {
      if (
        this.variantSizes.some((variantSize) => variantSize.id === size?.id)
      ) {
        this.selectedSize = size;
      }
    },
  },
};
